<template>
  <div class="logo-input-wrapper">
    <label>Logo</label>

    <p class="help">
      For best display, please pick an image with a resolution of 200x200.
    </p>

    <div class="input-grid">
      <div class="boxed-image lg">
        <img v-if="fileUri || product.logo" :src="fileUri || product.logo"  />
      </div>

      <div v-if="fileUri" class="btn-group vertical stretch">
        <button
          class="default-btn blue"
          @click="handleFileUpload">
        <v-icon v-if="saving" class="mr-2">mdi-loading mdi-spin</v-icon>
        Confirm Logo
      </button>

        <button
          class="default-btn text"
          @click="fileUri = null"
        >Cancel</button>
      </div>

      <template v-else>
        <button
          class="default-btn blue"
          @click="showFilePrompt"
        >Choose New Logo</button>
      </template>
    </div>

    <v-file-input
      class="hidden" ref="fileInput"
      accept="image/*" label="File input"
      solo
      @change="processFile" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'LogoInput',
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    fileUri: null,
    saving: false,
  }),

  computed: {
    ...mapGetters('feathers', ['apiProducts']),
  },

  methods: {
    showFilePrompt () {
      this.$refs.fileInput.$el.querySelector('input[type="file"]').click()
    },

    processFile (file) {
      const reader = new FileReader()
      reader.addEventListener('load', () => {
        this.fileUri = reader.result || null
      })
      reader.readAsDataURL(file)
    },

    async handleFileUpload () {
      if (this.saving) return
      this.saving = true

      try {
        const updated = await this.apiProducts.patch(this.product.id, {
          logoFile: { uri: this.fileUri },
        })

        this.$emit('change', { field: 'logo', value: updated.logo })
        this.addSuccessAlert('Your new logo has been saved')
        this.fileUri = null
      } catch (error) {
        this.addErrorAlert(`Could not upload the logo: ${error.message}`)
      }

      this.saving = false
    },
  },
}
</script>

<style lang="scss" scoped>
.input-grid {
  display: grid;
  grid-template-columns: auto;
  justify-content: flex-start;

  .boxed-image {
    border: 1px solid #00000029;
    margin: 0;
  }

  .default-btn {
    margin: 0;
    border-radius: 0;
  }

  .btn-group {
    grid-row-gap: 0;
  }
}
</style>
